// extracted by mini-css-extract-plugin
export default {"melodyVideo":"tM-z","isFullWidth":"uM-z","landingPageVideo":"vM-z","play":"wM-z","iframeVideo":"xM-z","playHidden":"yM-z","fullwidth":"zM-z"};